(function () {
	'use strict';
	angular
		.module('app.core')
		.directive('pipelineStepMarkFailed', pipelineStepMarkFailed);

	function pipelineStepMarkFailed($uibModal) {
		return {
			restrict: 'E',
			template: '<a class="data-pipeline-mark-failed" title="Mark job as failed" href="#" ng-click="$event.preventDefault();vm.openModal()"><i class="fa fa-times"></i></a>',
			scope: {
				factoryndx: '@',
				factory: '@',
				type: '@',
				jobid: '@'
			},
			controller: pipelineStepMarkFailedCtrl,
			controllerAs: 'vm'
		};
	}

	pipelineStepMarkFailedCtrl.$inject = ['$rootScope', '$scope', '$uibModal', 'dataPipelineService'];
	function pipelineStepMarkFailedCtrl($rootScope, $scope, $uibModal, dataPipelineService){
		var vm = this;
		vm.openModal = openModal;
		vm.factoryNdx = $scope.factoryndx;
		vm.factory = $scope.factory;
		vm.type = $scope.type;
		vm.jobId = $scope.jobid;		
	
		function openModal() {
			var modal = $uibModal.open({
				ariaLabelledBy: 'modal-title',
				ariaDescribedBy: 'modal-body',
				templateUrl: '/application/f/setup/mark-data-job-failed.html',
				controller: function($rootScope) {
					var vmModal = this;
					vmModal.closeModal = closeModal;
					vmModal.markFailed = markFailed;
					vmModal.factory = vm.factory;
					vmModal.typeDisplay = vm.type === 'Procurement' ? 'Analytics' : vm.type;
					
					function closeModal() {
						modal.close('cancel');
					}
			
					function markFailed() {
						dataPipelineService.markFailed(vm.factoryNdx, vm.jobId)
							.then(function(error) {
								if (error === '') {
									$rootScope.$emit('toast', {
										'message': 'Job marked as failed, refresh page to see current status',
										'success': true
									});
								} else {
									$rootScope.$emit('toast', {
										'message': error,
										'success': false
									});
								}
								modal.close('continue');
							});
					}
				},
				controllerAs: 'vm'
			});
		}
	}
})();
